import React from "react";
import { COLORS } from "../../utils/constants";
import { formatCurrency } from "../../utils/formatters";

const fr = (iso) => iso.split("-").reverse().join("/");

export const EcheancierTable = ({ sim }) => {
  const vl = sim.taux.versement_liberatoire > 0;
  return (
    <section className="space-y-2" data-testid="simulateur-echeancier">
      <h2 className="text-base md:text-lg font-semibold" style={{ color: COLORS.text }}>Ce qui te reste chaque mois</h2>
      <div className="rounded-xl border bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-muted-foreground border-b">
              <th className="p-3">Mois encaissé</th>
              <th className="p-3 text-right">Encaissement</th>
              <th className="p-3 text-right">Cotisations + CFP{vl ? " + versement libératoire" : ""}</th>
              <th className="p-3 text-right">À payer avant le</th>
              <th className="p-3 text-right">Ce qui te reste</th>
            </tr>
          </thead>
          <tbody>
            {sim.mensuel.map((m) => (
              <tr key={m.mois} className="border-b last:border-0" data-testid={`simulateur-mois-${m.mois}`}>
                <td className="p-3" style={{ color: COLORS.text }}>
                  <span className="capitalize">{m.label}</span>
                  {m.soumis_tva && <span className="ml-2 text-[10px] font-bold px-1.5 py-0.5 rounded" style={{ backgroundColor: COLORS.error + "20", color: COLORS.error }} data-testid={`simulateur-mois-tva-${m.mois}`}>TVA</span>}
                </td>
                <td className="p-3 text-right">{formatCurrency(m.encaissement)}</td>
                <td className="p-3 text-right" style={{ color: COLORS.accent }}>− {formatCurrency(m.total_prelevements)}</td>
                <td className="p-3 text-right text-muted-foreground">{fr(m.date_paiement)}</td>
                <td className="p-3 text-right font-semibold" style={{ color: COLORS.success }}>
                  {formatCurrency(m.net)}
                  {m.soumis_tva && <span className="block text-[10px] font-normal text-muted-foreground">{formatCurrency(m.net_si_prix_ttc)} si prix TTC inchangé</span>}
                </td>
              </tr>
            ))}
          </tbody>
          {sim.mensuel.length > 1 && (
            <tfoot>
              <tr className="font-semibold" style={{ backgroundColor: COLORS.bg }}>
                <td className="p-3">Total</td>
                <td className="p-3 text-right">{formatCurrency(sim.total_contrat)}</td>
                <td className="p-3 text-right" style={{ color: COLORS.accent }}>− {formatCurrency(sim.total_prelevements)}</td>
                <td className="p-3" />
                <td className="p-3 text-right" style={{ color: COLORS.success }}>{formatCurrency(sim.total_net)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      <p className="text-[11px] text-muted-foreground">
        Date limite selon ta déclaration {sim.frequence_declaration?.startsWith("trim") ? "trimestrielle" : "mensuelle"}. Hors dépenses liées au contrat.
      </p>
    </section>
  );
};

export default EcheancierTable;
